
import { Component, Prop, Vue } from 'vue-property-decorator';
import ProductGroupFilter from '@/components/orders/ProductGroupFilter.vue';
import ProductSearchField from '@/components/products/ProductSearchField.vue';

@Component({
  components: { ProductGroupFilter, ProductSearchField },
})
export default class ProductSearchBar extends Vue {
  @Prop({ type: String, default: 'order' })
  type!: 'order' | 'claim';

  active = false;

  hasClicked = false;

  screenWidth = 0;

  created() {
    window.addEventListener('resize', this.getScreenWidth);
    this.getScreenWidth();
  }

  getScreenWidth() {
    const { innerWidth } = window;
    const { clientWidth } = document.documentElement;

    this.screenWidth = innerWidth || clientWidth || document.body.clientWidth;
    this.active = this.screenWidth >= 768 || this.hasClicked;
  }

  toggleSearchBar() {
    this.hasClicked = !this.hasClicked;
    if (this.screenWidth < 768) {
      this.active = this.hasClicked;
    }
  }
}
